import { api } from './client';

export interface PlatformPermissionDef {
  id: string;
  code: string;
  /** 缺省仅拉取 PLATFORM 时可能不返回；scope=all 时有 */
  scope?: 'PLATFORM' | 'TENANT';
  resourceKind: 'API' | 'MENU' | 'BUTTON';
  name: string | null;
  description: string | null;
}

export interface SyncPermissionsFromSeedResponse {
  upserted: number;
  orphans: Array<{ id: string; code: string; scope: string }>;
}

export interface PlatformRoleRow {
  id: string;
  name: string;
  description: string | null;
  permissions: Array<{ permission: PlatformPermissionDef }>;
  menuItems?: Array<{ menuKey: string }>;
  _count: { users: number };
}

export interface PlatformMenuCatalogResponse {
  items: Array<{
    path: string;
    label: string;
    group?: string;
    permissions: string[];
    notes?: string;
  }>;
}

export const platformAdminRbacApi = {
  listPermissions: (scope?: 'PLATFORM' | 'TENANT' | 'all') =>
    api.get<PlatformPermissionDef[]>('/api/admin/platform-rbac/permissions', {
      params: scope ? { scope } : undefined,
    }),

  syncPermissionsFromSeed: () =>
    api.post<SyncPermissionsFromSeedResponse>(
      '/api/admin/platform-rbac/permissions/sync-from-seed',
    ),

  createPermission: (body: {
    code: string;
    scope: 'PLATFORM' | 'TENANT';
    resourceKind: 'API' | 'MENU' | 'BUTTON';
    name?: string;
    description?: string;
  }) => api.post<PlatformPermissionDef>('/api/admin/platform-rbac/permissions', body),

  updatePermission: (
    id: string,
    body: {
      resourceKind?: 'API' | 'MENU' | 'BUTTON';
      name?: string | null;
      description?: string | null;
    },
  ) =>
    api.patch<PlatformPermissionDef>(
      `/api/admin/platform-rbac/permissions/${id}`,
      body,
    ),

  deletePermission: (id: string) =>
    api.delete<{ success: boolean }>(
      `/api/admin/platform-rbac/permissions/${id}`,
    ),

  listRoles: () => api.get<PlatformRoleRow[]>('/api/admin/platform-rbac/roles'),

  getMenuCatalog: () =>
    api.get<PlatformMenuCatalogResponse>('/api/admin/platform-rbac/menu-catalog'),

  getRoleMenu: (roleId: string) =>
    api.get<{ menuKeys: string[] }>(
      `/api/admin/platform-rbac/roles/${roleId}/menu`,
    ),

  setRoleMenu: (roleId: string, menuKeys: string[]) =>
    api.put<PlatformRoleRow>(`/api/admin/platform-rbac/roles/${roleId}/menu`, {
      menuKeys,
    }),

  createRole: (body: {
    name: string;
    description?: string;
    permissionCodes: string[];
  }) => api.post<PlatformRoleRow>('/api/admin/platform-rbac/roles', body),

  updateRole: (
    id: string,
    body: {
      name?: string;
      description?: string;
      permissionCodes?: string[];
    },
  ) => api.patch<PlatformRoleRow>(`/api/admin/platform-rbac/roles/${id}`, body),

  deleteRole: (id: string) =>
    api.delete<{ success: boolean }>(`/api/admin/platform-rbac/roles/${id}`),
};
